import { createFileRoute, redirect } from "@tanstack/react-router";
import { FnbHalls } from "../../components/fnb/halls";
import { PageSkeleton } from "../../components/accommodation/page-skeleton";
import { useGamesTimeZone } from "../../components/travel-leg-form";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canManageFnb } from "../../lib/fnb/access";

/** Dining halls (her `#/fnb/halls`): the host F&B desk — admins and `fnb.manage` read and write halls and settings. */
export const Route = createFileRoute("/_app/logistics/food-beverages/halls")({
	beforeLoad: ({ context }) => {
		if (!canManageFnb(context.session)) throw redirect({ to: "/logistics/food-beverages" });
	},
	component: HallsPage,
});

function HallsPage() {
	const search = Route.useSearch();
	const gamesId = useDefaultGamesId(search.games_id);
	const timeZone = useGamesTimeZone(gamesId);
	if (!gamesId || !timeZone) return <PageSkeleton />;
	return <FnbHalls gamesId={gamesId} timeZone={timeZone} canWrite />;
}
